import React, { useState } from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { CONTACT_EMAIL } from '../data/content';
type Errors = {
  name?: string;
  email?: string;
  message?: string;
};
const fieldClass = 'mt-1.5 w-full rounded-lg border border-hairline bg-white px-3.5 py-2.5 text-[15px] text-ink placeholder:text-ink-light focus:border-accent focus:outline-none focus:ring-1 focus:ring-accent';
export function ContactForm() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [errors, setErrors] = useState<Errors>({});
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const next: Errors = {};
    if (!name.trim()) next.name = 'Please enter your name.';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) next.email = 'Please enter a valid email address.';
    if (!message.trim()) next.message = 'Please enter a message.';
    setErrors(next);
    if (Object.keys(next).length > 0) return;
    const subject = `Website enquiry from ${name.trim()}`;
    const body = `Name: ${name.trim()}\nEmail: ${email.trim()}\n\n${message.trim()}`;
    window.location.href = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    setSubmitted(true);
  };
  if (submitted) {
    return <div role="status" className="flex h-full flex-col items-start justify-center rounded-2xl border border-hairline bg-white p-8 shadow-card" data-id="element-46" data-mp="36nvkw6l3olkg">
        <CheckCircle2Icon className="h-7 w-7 text-accent" aria-hidden="true" data-id="element-47" data-mp="3gk8p3ye9uhtg" />
        <h3 className="mt-4 text-lg font-semibold text-ink" data-id="element-48" data-mp="3kltznd3c2k0h">
          Your email is ready to send
        </h3>
        <p className="mt-2 text-[15px] leading-relaxed text-ink-muted" data-id="element-49" data-mp="vussgmsdfyvw">
          We opened a pre-filled message in your email application. Send it and
          a member of our team will reply within two business days.
        </p>
        <a href={`mailto:${CONTACT_EMAIL}`} className="mt-4 break-all text-[15px] font-medium text-accent hover:text-accent-hover focus:outline-none focus-visible:ring-2 focus-visible:ring-accent" data-id="element-50" data-mp="2wv65kczu91bx">
          {CONTACT_EMAIL}
        </a>
      </div>;
  }
  return <form onSubmit={handleSubmit} noValidate className="rounded-2xl border border-hairline bg-white p-7 shadow-card sm:p-8" data-id="element-51" data-mp="30zdsq5qne981">
      <h3 className="text-lg font-semibold text-ink" data-id="element-52" data-mp="296wnnm5qwxq2">Send us a message</h3>
      <p className="mt-1.5 text-sm leading-relaxed text-ink-muted" data-id="element-53" data-mp="294tly4v8dg5i">
        Tell us briefly about your business and what you are looking for.
      </p>

      <div className="mt-6 space-y-5" data-id="element-54" data-mp="2i7ck4bo2n4lf">
        <div data-id="element-55" data-mp="2i69x4etvdmas">
          <label htmlFor="name" className="text-sm font-medium text-ink" data-id="element-56" data-mp="2i5rrwsp8bxqq">
            Name
          </label>
          <input id="name" name="name" type="text" autoComplete="name" value={name} onChange={e => setName(e.target.value)} aria-invalid={Boolean(errors.name)} aria-describedby={errors.name ? 'name-error' : undefined} className={fieldClass} placeholder="Jane Miller" data-id="element-57" data-mp="1pixak4nplehh" />
          {errors.name && <p id="name-error" className="mt-1.5 text-sm text-red-600" data-id="element-58" data-mp="yi1noevzbyf">
              {errors.name}
            </p>}
        </div>

        <div data-id="element-59" data-mp="opnc1o225c1c">
          <label htmlFor="email" className="text-sm font-medium text-ink" data-id="element-60" data-mp="on18dziafgoe">
            Email
          </label>
          <input id="email" name="email" type="email" autoComplete="email" value={email} onChange={e => setEmail(e.target.value)} aria-invalid={Boolean(errors.email)} aria-describedby={errors.email ? 'email-error' : undefined} className={fieldClass} placeholder="jane@company.com" data-id="element-61" data-mp="eqoep1mqt2tn" />
          {errors.email && <p id="email-error" className="mt-1.5 text-sm text-red-600" data-id="element-62" data-mp="3jqgegp37i15m">
              {errors.email}
            </p>}
        </div>

        <div data-id="element-63" data-mp="3ex3p2cqpdqbt">
          <label htmlFor="message" className="text-sm font-medium text-ink" data-id="element-64" data-mp="3ax3bsvfcbl6c">
            Message
          </label>
          <textarea id="message" name="message" rows={4} value={message} onChange={e => setMessage(e.target.value)} aria-invalid={Boolean(errors.message)} aria-describedby={errors.message ? 'message-error' : undefined} className={`${fieldClass} resize-y`} placeholder="A few lines about your company and your goals." data-id="element-65" data-mp="35yrzme1koyky" />
          {errors.message && <p id="message-error" className="mt-1.5 text-sm text-red-600" data-id="element-66" data-mp="2i8nz4fjoley6">
              {errors.message}
            </p>}
        </div>
      </div>

      <button type="submit" className="mt-6 w-full whitespace-nowrap rounded-lg bg-accent px-6 py-3 text-[15px] font-medium text-white transition-colors duration-150 ease-out hover:bg-accent-hover focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 sm:w-auto" data-id="element-67" data-mp="2d7zxz11qnhq8">
        Send
      </button>
    </form>;
}